import { useRemixFormContext } from 'remix-hook-form'
import {
	Field,
	type FieldProps,
	InputContainer,
	Label,
} from '#app/components/form/field.tsx'
import { Error, useForm } from '#app/components/form/form'
import { Input } from '#app/components/ui/input.tsx'

export function TextField({
	name,
	label,
	layout: fieldLayout,
	length,
	className,
	readOnly,
	disabled,
	alwaysShowError = false,
	placeholder,
	list,
	type,
	forceLowercase = false,
	emptyStringToUndefined = false,
}: {
	name: string
	label: string
	className?: string
	readOnly?: boolean
	disabled?: boolean
	copyButton?: boolean
	placeholder?: string
	list?: string
	type?: string
	forceLowercase?: boolean
	emptyStringToUndefined?: boolean
} & FieldProps & {
		length?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
	}) {
	const {
		register,
		formState: { errors },
		getFieldState,
	} = useRemixFormContext()

	const { layout: formLayout } = useForm()
	const { invalid, error } = getFieldState(name)
	const errorId = errors?.length ? `${name}-error` : undefined
	const layout = fieldLayout || formLayout

	return (
		<Field layout={layout} className={className}>
			<Label htmlFor={name} layout={layout}>
				{label}
			</Label>
			<InputContainer layout={layout}>
				<div className="relative">
					<Input
						id={name}
						autoComplete="off"
						layout={layout}
						type={type}
						length={length}
						state={invalid ? 'invalid' : undefined}
						aria-invalid={invalid ? true : undefined}
						aria-describedby={errorId}
						readOnly={readOnly}
						disabled={disabled}
						className="text-body-sm"
						placeholder={placeholder}
						list={list}
						onInput={(e) => {
							if (forceLowercase && e.currentTarget.value) {
								e.currentTarget.value = e.currentTarget.value.toLowerCase()
							}
						}}
						{...register(name, {
							setValueAs: emptyStringToUndefined
								? (v) => (v === '' ? undefined : v)
								: undefined,
						})}
					/>
				</div>
				{alwaysShowError && <Error id={errorId} error={error} />}
			</InputContainer>
		</Field>
	)
}
